import { createContext, useReducer, useMemo } from "react";
import reducer from "./reducer";
export const Context = createContext()

const initialState = {
    clicked: 0,
    user: {
        id: '',
        name: '',
        hasFlexTimeAccount: false,
        initialWorkingTimeBalance: 0,
        institute: '',
        location: {
            id: '',
            name: '',
            holidays: [],
            closingDays: [],
            isDefaultLocation: false,
        },
        contractInfo: {
            weeklyWorkLoad: 0,
            mondayWorkLoad: 0,
            tuesdayWorkLoad: 0,
            wednesdayWorkLoad: 0,
            thursdayWorkLoad: 0,
            fridayWorkLoad: 0,
            saturdayWorkLoad: 0,
            sundayWorkLoad: 0,
        },
        workDays: [],
        roles: [],
   },
};

export default function ContextProvider({ children }) {

    const [state, dispatch] = useReducer(reducer, initialState);
    const context = useMemo(() => ([state, dispatch]), [state]);

    return (
        <Context.Provider value={context}>
            {children}
        </Context.Provider>
    );
};
